module.exports = __webpack_public_path__ + "img/pencil.a638a3a1.svg";